import Vue from 'vue'

import Entrance from './views/entrance';
import NotFound from './views/404.vue';
import GagaDownload from './views/gaga/download.vue';

import MiYou from './routes/miyou';
import Privacy from './routes/privacy';
import Warning from './routes/warning';
import Events from './routes/events';
import Common from './routes/common';

import Page from './routes/page';
import Tianmi from './routes/tianmi';
import Share from './routes/share';
import XinBan from './routes/xinban';
import YinYuan from './routes/yinyuan';

import Profit from './routes/profit';
import Gaga from './routes/gaga';

Vue.config.productionTip = false

const routes = {
    '/': Entrance,
    ...Common,
    ...MiYou,
    ...Privacy,
    ...Warning,
    ...Events,
    ...Page,

    ...Tianmi,
    ...Share,
    ...XinBan,
    ...Gaga,

    ...Profit,
    ...YinYuan
};

// new Vue({
//   render: h => h(App),
// }).$mount('#app')

const app = new Vue({
    el: '#app',
    data: {
        currentRoute: window.location.pathname
    },

    computed: {
        ViewComponent() {
            document.title = '分享';
            // return GagaDownload;
            return routes[this.currentRoute] || NotFound;
        }
    },

    render(h) {
        return h(this.ViewComponent);
    }
})

window.addEventListener('popstate', () => {
    app.currentRoute = window.location.pathname;
})
